import React from "react";

const Social = () => {
    return (
        <div className="home_social">
            <a href="https://www.instagram.com/_shantanu_2002_/" className="home_social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/in/shantanu23/" className="home_social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-linkedin"></i>
            </a>

            <a href="https://github.com/Shantanuz06" className="home_social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-github"></i>
            </a>
        </div>
    )
}

export default Social